import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { BaseComponent } from '../../../base/base.component';
import { CustomCellRendererParams } from '../../models';

@Component({
  selector: 'app-base-renderer',
  templateUrl: './base-renderer.component.html',
  styleUrl: './base-renderer.component.scss',
})
export class BaseRendererComponent extends BaseComponent implements ICellRendererAngularComp {
  params: CustomCellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  setDataValue(field: string, value: any) {
    this.params.node.setDataValue(field, value);
  }

  get isAggregate() {
    return this.rowData?.isAggregate;
  }

  get isEditable(): boolean {
    return (this.params.colDef as any)?.editable(this.params as any) ?? false;
  }

  get cellData() {
    return this.rowData[this.colId];
  }

  get colId() {
    return this.params.column.getColId();
  }

  get rowData() {
    return this.params?.node?.data;
  }

  get rowIndex() {
    return this.params.node.rowIndex;
  }

  get show(): boolean {
    return !this.isAggregate && (!this.params?.show || this.params?.show(this.rowData));
  }
}
